/* global axios */
import ApiClient from './ApiClient';

class SearchAPI extends ApiClient {
  constructor() {
    super('search', { accountScoped: true });
  }

  get({ q }) {
    return axios.get(this.url, {
      params: {
        q,
      },
    });
  }

  contacts({ q, page = 1, since, until }) {
    return axios.get(`${this.url}/contacts`, {
      params: {
        q,
        page: page,
        since,
        until,
      },
    });
  }

  conversations({
    q,
    page = 1,
    since,
    until,
    inboxId,
    assigneeId,
    status,
    monitorMode,
  }) {
    return axios.get(`${this.url}/conversations`, {
      params: {
        q,
        page: page,
        since,
        until,
        inbox_id: inboxId,
        assignee_id: assigneeId,
        status,
        monitor_mode: monitorMode,
      },
    });
  }

  messages({
    q,
    page = 1,
    since,
    until,
    from,
    inboxId,
    qualityMode,
    assigneeId,
    status,
    attachmentsOnly,
    fileType,
    monitorMode,
    messageDirection,
  }) {
    return axios.get(`${this.url}/messages`, {
      params: {
        q,
        page: page,
        since,
        until,
        from,
        inbox_id: inboxId,
        quality_mode: qualityMode,
        assignee_id: assigneeId,
        status,
        attachments_only: attachmentsOnly,
        file_type: fileType,
        monitor_mode: monitorMode,
        message_direction: messageDirection,
      },
    });
  }

  qualitySummary({
    q,
    since,
    until,
    from,
    inboxId,
    assigneeId,
    status,
    messageDirection,
  }) {
    return axios.get(`${this.url}/quality_summary`, {
      params: {
        q,
        since,
        until,
        from,
        inbox_id: inboxId,
        assignee_id: assigneeId,
        status,
        quality_mode: true,
        message_direction: messageDirection,
      },
    });
  }

  articles({ q, page = 1, since, until }) {
    return axios.get(`${this.url}/articles`, {
      params: {
        q,
        page: page,
        since,
        until,
      },
    });
  }
}

export default new SearchAPI();
